var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159",
    "data-name": "Rectangle 2159",
    width: 24,
    height: 24,
    transform: "translate(-6718 -5172)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_blog",
    transform: "translate(6718 5172)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_blog-2",
    "data-name": "ic_blog",
    transform: "translate(-6718 -5170.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7507",
    "data-name": "Path 7507",
    d: "M80.937,42.541H83.75a.938.938,0,0,0,0-1.875H80.937a.938.938,0,0,0,0,1.875Zm0-3.75H83.75a.938.938,0,1,0,0-1.875H80.937a.938.938,0,1,0,0,1.875ZM86.443,41.6a.937.937,0,0,0,.937.938,7.291,7.291,0,0,0,5.19-2.15l6.856-6.857a2.813,2.813,0,1,0-3.977-3.977l-6.856,6.857A7.291,7.291,0,0,0,86.443,41.6Zm10.331-10.72A.937.937,0,1,1,98.1,32.209l-6.856,6.857a5.425,5.425,0,0,1-2.829,1.5,5.426,5.426,0,0,1,1.5-2.829Z",
    transform: "translate(-76.25 -28.735)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7508",
    "data-name": "Path 7508",
    d: "M2.812,102.015a2.809,2.809,0,0,0,1.875-.716l1.3-1.159h9.579a4.693,4.693,0,0,0,4.687-4.687v-2.1a.938.938,0,1,0-1.875,0v2.1a2.816,2.816,0,0,1-2.812,2.813H5.625A.937.937,0,0,0,5,98.5L3.437,99.9a.938.938,0,0,1-1.562-.7V87.952A2.816,2.816,0,0,1,4.687,85.14h7.863a.937.937,0,1,0,0-1.875H4.687A4.693,4.693,0,0,0,0,87.952V99.2A2.816,2.816,0,0,0,2.812,102.015Z",
    transform: "translate(0 -80.709)",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlog);
export default __webpack_public_path__ + "static/media/ic_blog.4d27c9a19265a2d86016399771933d37.svg";
export { ForwardRef as ReactComponent };